/**
 * Bitrix Messenger
 * Message constants
 *
 * @package bitrix
 * @subpackage im
 * @copyright 2001-2020 Bitrix
 */

export const MessageType = Object.freeze({
	self: 'self',
	opponent: 'opponent',
	system: 'system',
});